module.exports = __webpack_public_path__ + "img/jingyan_03.cb05c1b4.png";